import moment from "moment";
import React from "react";

const tableHeaderColumns = [
  {
    name: "ID",
    width: "10%",
  },
  {
    name: "Type",
    width: "10%",
  },
  {
    name: "Name",
    width: "30%",
  },
  {
    name: "Date Created",
    width: "30%",
  },
  {
    name: "Order",
    width: "20%",
  },
];

const documentsData = [
  {
    documentID: "001",
    documentType: "Proposal",
    documentName: "Project Proposal",
    documentDate: "2022-01-01",
    orderUsername: "JohnDoe",
  },
  {
    documentID: "002",
    documentType: "Contract",
    documentName: "Service Contract",
    documentDate: "2022-02-01",
    orderUsername: "JaneDoe",
  },
  {
    documentID: "003",
    documentType: "NDA",
    documentName: "Non-Disclosure Agreement",
    documentDate: "2022-03-01",
    orderUsername: "BobSmith",
  },
  {
    documentID: "004",
    documentType: "Invoice",
    documentName: "Monthly Invoice",
    documentDate: "2022-04-01",
    orderUsername: "AliceLee",
  },
  {
    documentID: "005",
    documentType: "Proposal",
    documentName: "Marketing Proposal",
    documentDate: "2022-05-01",
    orderUsername: "TomJones",
  },
];

export default function ClientDocumentsTablePreview() {
  return (
    <table className="w-full text-sm text-left text-gray-700 dark:text-gray-400">
      <thead className="text-sm text-gray-900 bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
        {tableHeaderColumns.map((column) => (
          <th scope="col" className="px-6 py-3" style={{ width: column.width }}>
            <button>{column.name}</button>
          </th>
        ))}
      </thead>
      <tbody>
        {documentsData &&
          documentsData.map((dataItem) => (
            <tr
              className="cursor-pointer bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
              key={dataItem.accountId}
            >
              <td className="px-6 py-2">{dataItem.documentID}</td>
              <td className="px-6 py-2">{dataItem.documentType}</td>
              <td className="px-6 py-2">{dataItem.documentName}</td>
              <td className="px-6 py-2">{moment(dataItem.documentDate).format("ddd, MMM Do")}</td>
              <td className="px-6 py-2">{dataItem.orderUsername.toLowerCase()}</td>
            </tr>
          ))}
      </tbody>
    </table>
  );
}
